import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../config/theme/baseTheme";
import { chipFilterStyles } from "SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      height: "100%",
    },
    container: {
      flexDirection: "column",
      "& .planningItem": {
        width: "100%",
        "& .MuiTab-root": {
          marginRight: 44,
        },
        "&.heading": {
          "& p": {
            fontSize: 20,
            lineHeight: "30px",
            color: COLORS.PRIMARY_MAIN,
            fontFamily: "Montserrat",
            fontWeight: 600,
          },
        },
        "&.content": {
          backgroundColor: COLORS.WHITE,
          borderRadius: theme.spacing(1),
          height: "calc(50vh)",
          "& .tabPanel": {
            height: "calc(100% - 56px)",
            padding: 0,
            "&.routes": {
              position: "relative",
            },
          },
        },
      },
    },
    tabPanelContainer: {
      flexDirection: "column",
      height: "100%",
      "& .panelItem": {
        width: "100%",
        "&.chipFilter": {
          padding: "16px 16px 16px 0px",
          "& .chipsContainer": {
            display: "flex",
            justifyContent: "space-between",
            "& .chipFilterItem": {
              height: 36,
              minWidth: "16%",
              ...chipFilterStyles(theme),
            },
          },
        },
        "&.gridWrapper": {
          height: "calc(100% - 98px)",
          "& .idLink": {
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 12,
          },
          "& .actionsLink": {
            cursor: "pointer",
            color: theme.palette.primary.main,
            fontWeight: 600,
            fontSize: 14,
          },
        },
      },
    },
    sentCommunicationContainer: {
      backgroundColor: COLORS.ALICE_GRAY,
      borderRadius: "38px",
      padding: "4px 12px",
      display: "flex",
      alignItems: "center",
      border: `0.5px solid ${COLORS.ALTO}`,
      gap: "8px", // Adds spacing between the text and buttons
    },
    closeIcon: {
     color: COLORS.PRIMARY_MAIN,
      borderRadius: "50%",
      width: "16px",
      height: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "10px",
      cursor: "pointer",
      fontWeight: 600,
    },
    renderButton: {
      borderRadius: "38px",
      padding: "8px 24px",
      marginRight: "4px",
      cursor: "pointer",
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "8px",
      border: "1px solid #DCDCDC",
      backgroundColor: "white",
      color: "#000",
      fontWeight: 600,
      "&.active": {
        backgroundColor: `${COLORS.PRIMARY_MAIN}0D`,
        color: COLORS.PRIMARY_MAIN,
        border: `1px solid ${COLORS.PRIMARY_MAIN}`,
        padding: "6px 12px", // Reduced padding when active
      },
    },
  })
);
